import React from "react"
export function RightChevronOutline(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M10 2a8 8 0 110 16 8 8 0 010-16zm0 1a7 7 0 100 14 7 7 0 000-14zM8.972 5.599l3.5 4a.75.75 0 01.066.899l-.066.089-3.5 4-1.13-.988 3.068-3.506-3.067-3.506 1.129-.988z"
        fill="currentColor"
        fillRule="nonzero"
        id="prefix__right-chevron---outline"
        stroke="none"
        strokeWidth={1}
      />
    </svg>
  )
}
